<template>
  <div class="container">
    <div class="form-title">申请人基本信息</div>
    <div class="form">
      <div class="form-item">
        <div class="item-name">姓名<span class="red-txt">*</span></div>
        <van-field class="field" :disabled="form.state == 1 || form.state == 2" v-model="form.name" placeholder="请输入真实姓名" />
      </div>
      <div class="form-item">
        <div class="item-name">手机号<span class="red-txt">*</span></div>
        <van-field class="field" disabled v-model="phone" type="tel" placeholder="请输入手机号码" />
      </div>
      <div class="form-item">
        <div class="item-name">身份证号<span class="red-txt">*</span></div>
        <van-field class="field" :disabled="form.state == 1 || form.state == 2" v-model="form.idcard" placeholder="请输入身份证号" />
      </div>
      <div class="form-item">
        <div class="item-name">开立机构<span class="red-txt">*</span></div>
        <van-field class="field" readonly v-model="form.bankTxt" @click="handleShowAction" right-icon="arrow" placeholder="请选择数字人民币钱包开立机构"></van-field>
      </div>
      <div class="form-item">
        <div class="item-name">数字人民币账户<span class="red-txt">*</span></div>
        <van-field class="field" disabled v-model="phone" placeholder="请输入数字人民币手机号" />
        <div class="red-tips-txt">注：此账户为申请审核通过后，补贴发放的数字人民币手机号</div>
      </div>
      <div class="form-item">
        <div class="item-name">身份证正面<span class="red-txt">*</span></div>
        <van-uploader :before-read="beforeRead" :after-read="afterFrontID()" :disabled="form.state == 1 || form.state == 2" v-model="front_idcard_img" class="uploader" upload-icon="plus" multiple :max-count="1" />
      </div>
      <div class="form-item">
        <div class="item-name">身份证反面<span class="red-txt">*</span></div>
        <van-uploader :before-read="beforeRead" :after-read="afterBackID()" :disabled="form.state == 1 || form.state == 2" v-model="back_idcard_img" class="uploader" upload-icon="plus" multiple :max-count="1" />
      </div>
      <div class="form-item">
        <div class="item-name">行驶证<span class="red-txt">*</span></div>
        <van-uploader :before-read="beforeRead" :after-read="afterReadDrive()" :disabled="form.state == 1 || form.state == 2" v-model="drive_img" class="uploader" upload-icon="plus" multiple :max-count="1" />
      </div>
    </div>
    <div class="form-title">购车信息</div>
    <div class="form">
      <div class="form-item">
        <div class="item-name">经销商<span class="red-txt">*</span></div>
        <van-field class="field" readonly v-model="form.dealersTxt" @click="handleShowDealers" right-icon="arrow" placeholder="请选择经销商"></van-field>
      </div>
      <!-- <div class="form-item">
        <div class="item-name">车辆类型<span class="red-txt">*</span></div>
        <van-field class="field" readonly v-model="form.typeTxt" @click="handleShowType" right-icon="arrow" placeholder="请选择车辆类型"></van-field>
      </div> -->
      <div class="form-item">
        <div class="item-name">购车金额（元）<span class="red-txt">*</span></div>
        <van-field class="field" :disabled="form.state == 1 || form.state == 2" v-model="form.purchase_amount" type="number" placeholder="请输入机动车销售统一发票上含税价" />
      </div>
      <div class="form-item">
        <div class="item-name">新购车辆合同（网上订车可提供截图）<span class="red-txt">*</span></div>
        <van-uploader :before-read="beforeRead" :after-read="afterReadContract()" :disabled="form.state == 1 || form.state == 2" v-model="contract_img" class="uploader" upload-icon="plus" multiple :max-count="3" />
      </div>
      <div class="form-item">
        <div class="item-name">定（订）金票据<span class="red-txt">*</span></div>
        <van-uploader :before-read="beforeRead" :after-read="afterReadDeposit()" :disabled="form.state == 1 || form.state == 2" v-model="deposit_paper" class="uploader" upload-icon="plus" multiple :max-count="1" />
      </div>
      <div class="form-item">
        <div class="item-name">机动车销售统一发票<span class="red-txt">*</span></div>
        <van-uploader :before-read="beforeRead" :after-read="afterReadPurchase()" :disabled="form.state == 1 || form.state == 2" v-model="purchase_bill_img" class="uploader" upload-icon="plus" multiple :max-count="1" />
      </div>
      <div class="form-item">
        <div class="item-name">用数字人民币支付定（订）金的凭证<span class="red-txt">*</span></div>
        <van-uploader :before-read="beforeRead" :after-read="afterReadCredentials()" :disabled="form.state == 1 || form.state == 2" v-model="credentials_img" class="uploader" upload-icon="plus" multiple :max-count="3" />
      </div>
      <div class="form-item">
        <div class="item-name">其他凭证（作为补充凭证，非必填，最多9张）</div>
        <van-uploader :before-read="beforeRead" :after-read="afterReadOther()" :disabled="form.state == 1 || form.state == 2" v-model="other_img" class="uploader" upload-icon="plus" multiple :max-count="9" />
      </div>
      <div class="form-item" v-if="form.state == 3">
        <div class="item-name">审核失败原因</div>
        <div class="red-tips-txt">{{ form.refuse_reason }}</div>
      </div>
    </div>
    <van-action-sheet v-model="showAction" :actions="actions" @select="onSelect" />
    <van-action-sheet v-model="showDealers" :actions="dealersList" @select="onSelectDealers" />
    <van-action-sheet v-model="showType" :actions="typeList" @select="onSelectType" />
    <div class="footer">
      <div class="save-btn" @click="handleAdd" v-if="form.state == 0">提交</div>
      <div class="save-btn" v-if="form.state == 1" @click="$toast('您已提交申请，请耐心等待审核')">待审核</div>
      <div class="save-btn" v-if="form.state == 2" @click="$toast('您享受一辆新购汽车补贴，无法再次申请！')">审核通过</div>
      <div class="save-btn" v-if="form.state == 4" @click="$toast('您已获得抽奖机会，无法再次申请！')">审核通过，您已获得抽奖机会</div>
      <div class="save-btn" @click="handleAdd" v-if="form.state == 3">提交修改</div>
    </div>
    <van-overlay :show="showOverlay" :lock-scroll="false" @click="showOverlay = false">
      <div class="wrapper">
        <div class="block" @click.stop>
          <div class="title">信息确认</div>
          <div class="wrapper-form-title">申请人基本信息</div>
          <div class="wrapper-form-item">
            <div><span class="red-txt">*</span>姓名:</div>
            <div class="content">{{ form.name }}</div>
          </div>
          <div class="wrapper-form-item">
            <div><span class="red-txt">*</span>手机号:</div>
            <div class="content">{{ form.mobile }}</div>
          </div>
          <div class="wrapper-form-item">
            <div><span class="red-txt">*</span>身份证号:</div>
            <div class="content">{{ form.idcard }}</div>
          </div>
          <div class="wrapper-form-item">
            <div><span class="red-txt">*</span>开立机构:</div>
            <div class="content">{{ form.bankTxt }}</div>
          </div>
          <div class="wrapper-form-item">
            <div><span class="red-txt">*</span>数字人民币账户:</div>
            <div class="content">{{ form.account }}</div>
          </div>
          <div class="wrapper-form-item">
            <div class="wrapper-form-item-noflex">
              <div><span class="red-txt">*</span>身份证正面:</div>
              <van-image width="100" height="100" style="margin-top: 10px;" v-if="front_idcard_img.length > 0" :src="front_idcard_img[0].content" @click="preImage([...front_idcard_img[0].content])" />
            </div>
            <div class="wrapper-form-item-noflex">
              <div><span class="red-txt">*</span>身份证反面:</div>
              <van-image width="100" height="100" style="margin-top: 10px;" v-if="back_idcard_img.length > 0" :src="back_idcard_img[0].content" @click="preImage([...back_idcard_img[0].content])" />
            </div>
          </div>
          <div class="wrapper-form-item">
            <div class="wrapper-form-item-noflex">
              <div><span class="red-txt">*</span>行驶证:</div>
              <van-image width="100" height="100" style="margin-top: 10px;" v-if="drive_img.length > 0" :src="drive_img[0].content" @click="preImage([...drive_img[0].content])" />
            </div>
          </div>
          <div class="wrapper-form-title">购车信息</div>
          <div class="wrapper-form-item">
            <div style="flex-shrink: 0;"><span class="red-txt">*</span>经销商:</div>
            <div class="content">{{ form.dealersTxt }}</div>
          </div>
          <!-- <div class="wrapper-form-item">
            <div><span class="red-txt">*</span>车辆类型:</div>
            <div class="content">{{ form.typeTxt }}</div>
          </div> -->
          <div class="wrapper-form-item">
            <div><span class="red-txt">*</span>购车金额:</div>
            <div class="content">{{ form.purchase_amount }}元</div>
          </div>
          <div class="wrapper-form-item">
            <div class="wrapper-form-item-noflex" v-if="contract_img.length > 0">
              <div><span class="red-txt">*</span>新购车辆合同:</div>
              <van-image width="100" height="100" style="margin-right: 10px; margin-top: 10px;" v-for="item in contract_img" :key="item.id" :src="item.content" @click="preImage([...item.content])" />
            </div>
          </div>
          <div class="wrapper-form-item">
            <div class="wrapper-form-item-noflex">
              <div><span class="red-txt">*</span>机动车销售统一发票:</div>
              <van-image width="100" height="100" style="margin-top: 10px;" v-if="purchase_bill_img.length > 0" :src="purchase_bill_img[0].content" @click="preImage([...purchase_bill_img[0].content])" />
            </div>
            <div class="wrapper-form-item-noflex">
              <div><span class="red-txt">*</span>定（订）金票据:</div>
              <van-image width="100" height="100" style="margin-top: 10px;" v-if="deposit_paper.length > 0" :src="deposit_paper[0].content" @click="preImage([...deposit_paper[0].content])" />
            </div>
          </div>
          <div class="wrapper-form-item">
            <div class="wrapper-form-item-noflex" v-if="credentials_img.length > 0">
              <div><span class="red-txt">*</span>用数字人民币支付定（订）金的凭证:</div>
              <van-image width="100" height="100" style="margin-right: 10px; margin-top: 10px;" v-for="item in credentials_img" :key="item.id" :src="item.content" @click="preImage([item.content])" />
            </div>
          </div>
          <div class="wrapper-form-item">
            <div class="wrapper-form-item-noflex" v-if="other_img.length > 0">
              <div>其他凭证（作为补充凭证，非必填，最多9张）:</div>
              <van-image width="100" height="100" style="margin-right: 10px; margin-top: 10px;" v-for="item in other_img" :key="item.id" :src="item.content" @click="preImage([item.content])" />
            </div>
          </div>
          <div class="red-txt">请仔细查看各项信息是否填写（上传）是否正确，一旦提交审核将无法修改！</div>
          <div class="sub-btn" @click="handleSubmit">确认提交</div>
          <van-image-preview v-model="showImagePre" :images="images"></van-image-preview>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import service from '@/utils/axios'
import Compressor from 'compressorjs'
import { apply, getInstitutions, getDealers, getDetails, getHaveDiscount } from '@/service/gxqgouche2212/index'
export default {
  name: 'AddCar',
  data() {
    return {
      showImagePre: false,
      images: [],
      showType: false,
      showDealers: false,
      actions: [], // 开立机构列表
      dealersList: [], // 经销商列表
      showOverlay: false,
      lock: true,
      minDate: new Date(1990, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      showAction: false,
      show: false,
      front_idcard_img: [],
      back_idcard_img: [],
      drive_img: [],
      contract_img: [],
      deposit_paper: [],
      purchase_bill_img: [],
      credentials_img: [],
      other_img: [],
      form: {
        refuse_reason: '',
        state: '',
        name: '',
        mobile: '',
        idcard: '',
        bankTxt: '',
        dealersTxt: '',
        typeTxt: '',
        account: '', // 数字人民币账户
        open_institutions_id: '', // 开立机构id
        dealers_id: '', // 经销商id
        // car_tpe: '', // 汽车类型 1燃油车 2新能源
        car_tpe: '1', // 汽车类型 1燃油车 2新能源
        front_idcard_img: '', // 身份证正面照
        back_idcard_img: '', // 身份证反面照
        drive_img: '', // 行驶证多张|||隔开
        purchase_amount: '', // 购车金额
        contract_img: '', // 新购车合同，多张|||隔开
        deposit_paper: '', // 定金票据
        purchase_bill_img: '', // 机动车销售统一发票
        credentials_img: '', // 购车款凭证/数字人民币车贷凭证
        other_img: '' // 其他凭证
      },
      typeList: [
        {
          id: '1',
          name: '燃油车(蓝牌)'
        },
        {
          id: '2',
          name: '新能源汽车(绿牌)'
        }
      ]
    }
  },
  destroyed() {
    if (this.toast) {
      this.toast.clear()
    }
  },
  computed: {
    phone() {
      return this.encryptPhone(this.form.mobile)
    }
  },
  created() {
    this.form.mobile = sessionStorage.getItem('gxqgc2212_mobile')
    this.form.account = sessionStorage.getItem('gxqgc2212_mobile')
    // 获取开立结构列表
    getInstitutions().then((res) => {
      this.actions = res.data
    })
    // 获取经销商列表
    getDealers().then((res) => {
      this.dealersList = res.data
    })
  },
  mounted() {
    this.show = true
    // 获取提交信息
    this.toast = this.$toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: '加载中'
    })
    getDetails()
      .then((res) => {
        console.log(res.data)
        if (JSON.stringify(res.data) == '{}') {
          console.log('暂无信息')
          this.form.state == 0
        } else {
          this.form = res.data
          this.$set(this.form, 'bankTxt', this.form.open_institutions_name)
          this.$set(this.form, 'dealersTxt', this.form.dealers_name)
          if (this.form.car_tpe == 1) {
            this.$set(this.form, 'typeTxt', '燃油车(蓝牌)')
          } else {
            this.$set(this.form, 'typeTxt', '新能源汽车(绿牌)')
          }
          if (this.form.front_idcard_img) {
            let img_arr = this.form.front_idcard_img.split('|||')
            let img_path_arr = this.form.front_idcard_img_path.split('|||')
            for (let i = 0; i < img_arr.length; i++) {
              let obj = {
                content: img_arr[i],
                isImage: true,
                file: '',
                message: '',
                status: 'done',
                url: img_path_arr[i]
              }
              this.front_idcard_img.push(obj)
            }
          }
          if (this.form.back_idcard_img) {
            let img_arr = this.form.back_idcard_img.split('|||')
            let img_path_arr = this.form.back_idcard_img_path.split('|||')
            for (let i = 0; i < img_arr.length; i++) {
              let obj = {
                content: img_arr[i],
                isImage: true,
                file: '',
                message: '',
                status: 'done',
                url: img_path_arr[i]
              }
              this.back_idcard_img.push(obj)
            }
          }
          if (this.form.drive_img) {
            let img_arr = this.form.drive_img.split('|||')
            let img_path_arr = this.form.drive_img_path.split('|||')
            for (let i = 0; i < img_arr.length; i++) {
              let obj = {
                content: img_arr[i],
                isImage: true,
                file: '',
                message: '',
                status: 'done',
                url: img_path_arr[i]
              }
              this.drive_img.push(obj)
            }
          }
          if (this.form.contract_img) {
            let img_arr = this.form.contract_img.split('|||')
            let img_path_arr = this.form.contract_img_path.split('|||')
            for (let i = 0; i < img_arr.length; i++) {
              let obj = {
                content: img_arr[i],
                isImage: true,
                file: '',
                message: '',
                status: 'done',
                url: img_path_arr[i]
              }
              this.contract_img.push(obj)
            }
          }
          if (this.form.deposit_paper) {
            let img_arr = this.form.deposit_paper.split('|||')
            let img_path_arr = this.form.deposit_paper_path.split('|||')
            for (let i = 0; i < img_arr.length; i++) {
              let obj = {
                content: img_arr[i],
                isImage: true,
                file: '',
                message: '',
                status: 'done',
                url: img_path_arr[i]
              }
              this.deposit_paper.push(obj)
            }
          }
          if (this.form.purchase_bill_img) {
            let img_arr = this.form.purchase_bill_img.split('|||')
            let img_path_arr = this.form.purchase_bill_img_path.split('|||')
            for (let i = 0; i < img_arr.length; i++) {
              let obj = {
                content: img_arr[i],
                isImage: true,
                file: '',
                message: '',
                status: 'done',
                url: img_path_arr[i]
              }
              this.purchase_bill_img.push(obj)
            }
          }
          if (this.form.credentials_img) {
            let img_arr = this.form.credentials_img.split('|||')
            let img_path_arr = this.form.credentials_img_path.split('|||')
            for (let i = 0; i < img_arr.length; i++) {
              let obj = {
                content: img_arr[i],
                isImage: true,
                file: '',
                message: '',
                status: 'done',
                url: img_path_arr[i]
              }
              this.credentials_img.push(obj)
            }
          }
          if (this.form.other_img) {
            let img_arr = this.form.other_img.split('|||')
            let img_path_arr = this.form.other_img_path.split('|||')
            for (let i = 0; i < img_arr.length; i++) {
              let obj = {
                content: img_arr[i],
                isImage: true,
                file: '',
                message: '',
                status: 'done',
                url: img_path_arr[i]
              }
              this.other_img.push(obj)
            }
          }
        }
        this.toast.clear()
      })
      .catch(() => {
        this.toast.clear()
      })
  },
  methods: {
    encryptPhone(str) {
      if (null != str && str != undefined) {
        let pat = /(\d{3})\d*(\d{4})/
        return str.replace(pat, '$1****$2')
      } else {
        return ''
      }
    },
    preImage(arr) {
      console.log(arr, 'arr')
      this.showImagePre = true
      this.images = arr
    },
    handleShowDealers() {
      if (this.form.state != 1 && this.form.state != 2) {
        this.showDealers = true
      }
    },
    handleShowAction() {
      if (this.form.state != 1 && this.form.state != 2) {
        this.showAction = true
      }
    },
    handleShowType() {
      if (this.form.state != 1 && this.form.state != 2) {
        this.showType = true
      }
    },
    onSelect(value) {
      this.form.bankTxt = value.name
      this.form.open_institutions_id = value.id
      this.showAction = false
    },
    onSelectDealers(value) {
      this.form.dealersTxt = value.name
      this.form.dealers_id = value.id
      this.showDealers = false
    },
    onSelectType(value) {
      this.form.typeTxt = value.name
      this.form.car_tpe = value.id
      this.showType = false
    },
    // 校验身份证号
    checkID(val) {
      if (this.checkCode(val)) {
        var date = val.substring(6, 14)
        if (this.checkDate(date)) {
          if (this.checkProv(val.substring(0, 2))) {
            return true
          }
        }
      }
      return false
    },
    // 校验校验码
    checkCode(val) {
      var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var code = val.substring(17)
      if (p.test(val)) {
        var sum = 0
        for (var i = 0; i < 17; i++) {
          sum += val[i] * factor[i]
        }
        if (parity[sum % 11] == code.toUpperCase()) {
          return true
        }
      }
      return false
    },
    // 校验出生日期
    checkDate(val) {
      var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/
      if (pattern.test(val)) {
        var year = val.substring(0, 4)
        var month = val.substring(4, 6)
        var date = val.substring(6, 8)
        var date2 = new Date(year + '-' + month + '-' + date)
        if (date2 && date2.getMonth() == parseInt(month) - 1) {
          return true
        }
      }
      return false
    },
    // 校验省级地址码
    checkProv(val) {
      var pattern = /^[1-9][0-9]/
      var provs = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门'
      }
      if (pattern.test(val)) {
        if (provs[val]) {
          return true
        }
      }
      return false
    },
    handleSubmit() {
      let front_idcard_arr = []
      this.front_idcard_img.forEach((item) => {
        front_idcard_arr.push(item.url)
      })
      this.form.front_idcard_img = front_idcard_arr.join('|||')
      let back_idcard_arr = []
      this.back_idcard_img.forEach((item) => {
        back_idcard_arr.push(item.url)
      })
      this.form.back_idcard_img = back_idcard_arr.join('|||')
      let drive_img_arr = []
      this.drive_img.forEach((item) => {
        drive_img_arr.push(item.url)
      })
      this.form.drive_img = drive_img_arr.join('|||')
      let contract_img_arr = []
      this.contract_img.forEach((item) => {
        contract_img_arr.push(item.url)
      })
      this.form.contract_img = contract_img_arr.join('|||')
      let deposit_paper_arr = []
      this.deposit_paper.forEach((item) => {
        deposit_paper_arr.push(item.url)
      })
      this.form.deposit_paper = deposit_paper_arr.join('|||')
      let purchase_bill_img_arr = []
      this.purchase_bill_img.forEach((item) => {
        purchase_bill_img_arr.push(item.url)
      })
      this.form.purchase_bill_img = purchase_bill_img_arr.join('|||')
      let credentials_img_arr = []
      this.credentials_img.forEach((item) => {
        credentials_img_arr.push(item.url)
      })
      this.form.credentials_img = credentials_img_arr.join('|||')
      let other_img_arr = []
      this.other_img.forEach((item) => {
        other_img_arr.push(item.url)
      })
      this.form.other_img = other_img_arr.join('|||')
      if (this.lock) {
        this.lock = false
        const toast = this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '提交中'
        })
        this.form.idcard = this.form.idcard.toUpperCase()
        apply(this.form)
          .then(() => {
            toast.clear()
            // this.$toast('提交成功，活动主办方将在3-5个工作日内进行审核，请耐心等待')
            this.$toast('提交成功，活动主办方将尽快进行审核，请耐心等待')
            setTimeout(() => {
              this.lock = true
              this.$router.push('/home')
            }, 1000)
          })
          .catch((err) => {
            toast.clear()
            this.$toast(err)
            this.lock = true
          })
      }
    },
    handleAdd() {
      if (!this.form.name) {
        this.$toast('请输入姓名')
        return false
      }
      if (!this.form.mobile) {
        this.$toast('请输入手机号')
        return false
      } else {
        let myreg = /^[1][0-9]{10}$/
        if (!myreg.test(this.form.mobile)) {
          this.$toast('请输入正确的手机号')
          return false
        }
      }
      if (!this.form.idcard) {
        this.$toast('请输入身份证号')
        return false
      } else {
        if (this.checkID(this.form.idcard) === false) {
          this.$toast('身份证输入不合法')
          return false
        }
      }
      if (!this.form.open_institutions_id) {
        this.$toast('请选择个人数字钱包开立机构')
        return false
      }
      if (!this.form.account) {
        this.$toast('请输入数字人民币手机号')
        return false
      } else {
        let myreg = /^[1][0-9]{10}$/
        if (!myreg.test(this.form.account)) {
          this.$toast('请输入正确的手机号')
          return false
        }
      }
      if (!this.front_idcard_img.length > 0) {
        this.$toast('请上传身份证正面照')
        return false
      }
      if (!this.back_idcard_img.length > 0) {
        this.$toast('请上传身份证反面照')
        return false
      }
      if (!this.drive_img.length > 0) {
        this.$toast('请上传行驶证')
        return false
      }
      if (!this.form.dealers_id) {
        this.$toast('请选择经销商')
        return false
      }
      if (!this.form.car_tpe) {
        this.$toast('请选择汽车类型')
        return false
      }
      if (!this.form.purchase_amount) {
        this.$toast('请输入购车金额')
        return false
      } else {
        if (parseFloat(this.form.purchase_amount) < 100000) {
          this.$toast('购车金额不符合申请标准')
          return false
        }
      }
      if (!this.contract_img.length > 0) {
        this.$toast('请上传新购车辆合同')
        return false
      }
      if (!this.deposit_paper.length > 0) {
        this.$toast('请上传定（订）金票据')
        return false
      }
      if (!this.purchase_bill_img.length > 0) {
        this.$toast('请上传机动车销售统一发票')
        return false
      }
      if (!this.credentials_img.length > 0) {
        this.$toast('请上传用数字人民币支付定（订）金的凭证')
        return false
      }
      console.log('other_img', this.other_img)
      this.validateDiscount()
      // this.showOverlay = true
    },
    validateDiscount() {
      getHaveDiscount(this.form.car_tpe, this.form.purchase_amount)
        .then((res) => {
          if (res.data.state == '0') {
            this.openNoDiscountConfirm()
          } else {
            this.showOverlay = true
          }
        })
        .catch((err) => {
          Toast.fail(err)
        })
    },
    openNoDiscountConfirm() {
      Dialog.confirm({
        message: `${this.form.typeTxt}补贴已申领完毕，您已进入申请抽奖环节。 是否继续？`,
        confirmButtonColor: '#131177'
      }).then(() => {
        this.showOverlay = true
      })
    },
    uploadFile(arr) {
      // 此时可以自行将文件上传至服务器
      for (let i in arr) {
        if (!arr[i].status) {
          arr[i].status = 'uploading'
          arr[i].message = '上传中...'
          let type = arr[i].file.type.split('/')
          let suffix = type[type.length - 1]
          const formData = new FormData()
          let uploadUrl = ''
          if (!window.location.origin.includes('2500city')) {
            uploadUrl = `https://huodong-test.chinacici.com/api/221212/apply/upload?nonce=${new Date().getTime() + Math.round(Math.random() * 1000000000000)}`
          } else {
            uploadUrl = process.env.VUE_APP_BASE_API + `/api/221212/apply/upload?nonce=${new Date().getTime() + Math.round(Math.random() * 1000000000000)}`
          }
          formData.append('file', arr[i].file, `${new Date().getTime()}.${suffix}`)
          const opts = {
            method: 'POST',
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' }
          }
          service(uploadUrl, opts)
            .then((response) => {
              if (response.code == 0 && response.data.url != '') {
                arr[i].status = 'done'
                arr[i].message = ''
                arr[i].url = response.data.path
              }
            })
            .catch((err) => {
              this.$toast(err)
              arr[i].status = 'failed'
              arr[i].message = '上传失败'
            })
        }
      }
    },
    beforeRead(file) {
      if (this.form.state != 1 && this.form.state != 2) {
        console.log('file', file)
        return new Promise((resolve) => {
          // compressorjs 默认开启 checkOrientation 选项
          // 会将图片修正为正确方向
          let fileList = []
          let promiseList = []
          if (Array.isArray(file)) {
            fileList = file
          } else {
            fileList = [file]
          }
          for (let i in fileList) {
            promiseList.push(
              new Promise((resolve2) => {
                new Compressor(fileList[i], {
                  quality: 0.3,
                  success: resolve2,
                  error(err) {
                    console.log(err.message)
                  }
                })
              })
            )
          }
          Promise.all(promiseList).then((res) => {
            console.log(res)
            resolve(res)
          })
        })
      } else {
        this.$toast('当前审核状态不支持上传')
      }
    },
    afterReadContract() {
      this.uploadFile(this.contract_img)
    },
    afterReadDeposit() {
      this.uploadFile(this.deposit_paper)
    },
    afterReadPurchase() {
      this.uploadFile(this.purchase_bill_img)
    },
    afterReadCredentials() {
      this.uploadFile(this.credentials_img)
    },
    afterReadOther() {
      this.uploadFile(this.other_img)
    },
    afterReadPay() {
      this.uploadFile(this.pay_img)
    },
    afterFrontID() {
      this.uploadFile(this.front_idcard_img)
    },
    afterBackID() {
      this.uploadFile(this.back_idcard_img)
    },
    afterReadDrive() {
      this.uploadFile(this.drive_img)
    },
    afterRead() {
      this.uploadFile(this.purchase_bill_img)
    }
  }
}
</script>

<style lang="stylus" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 650px;
  height: 80%;
  position: relative
  overflow-y: scroll
  background-color: #fff;
  border-radius: 20px;
  padding: 30px;
  .sub-btn{
    background: rgb(19,28,225);
    border-radius: 44px;
    text-align: center;
    color: #ffffff;
    height: 88px;
    margin-top: 30px;
    line-height: 88px;
  }
  .title{
    font-size: 34px;
    text-align: center;
    color: #111111;
    font-weight: bold;
  }
  .wrapper-form-title{
    font-size: 30px;
    font-weight: bold;
    color: #111111;
    padding 23px 30px
  }
  .wrapper-form-title::before{
    content: ''
    width: 8px;
    height: 40px;
    background: rgb(19,28,225)
    position: absolute
    left 30px;
  }
  .wrapper-form-item{
    color: #666666
    font-size: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .content{
      color: #111111;
    }
  }
  .wrapper-form-item-noflex{
    color: #666666
    font-size: 30px;
    // display: flex;
    // justify-content: space-between;
    margin-bottom: 20px;
    .content{
      color: #111111;
    }
  }
}
/deep/ .van-icon-arrow:before
  color #131177 !important
/deep/ .van-uploader__upload
  background: #FFFFFF;
  box-shadow: 0px 0px 15px 0px rgba(176, 200, 220, 0.4);
  border-radius: 10px;
/deep/ .van-uploader__upload-icon
  color #131177
.red-txt
  color red
.container
  height 100%
  overflow-y scroll
  position relative
  background: #f0f2f5
  padding-bottom 167px
  .form-title
    background: #EEEEEE;
    font-size: 30px;
    font-weight: bold;
    color: #111111;
    padding 23px 70px
  .form-title::before
    content: ''
    width: 8px;
    height: 40px;
    background: rgb(19,28,225)
    position: absolute
    left 50px;
  .form
    // margin-bottom 167px
    padding 0 50px
    .form-item
      margin 20px 0
      .img-list
        display flex
        .img-list-item
          width: 150px;
          height: 150px;
          border-radius: 10px;
          margin-right 10px
    .item-name
      font-size: 34px;
      font-weight: 600;
      color: #131177;
      margin-bottom 24px
    .field
      background: #FFFFFF;
      box-shadow: 0px 0px 15px 0px rgba(176, 200, 220, 0.4);
      border-radius: 10px;
  .footer
    background #f0f2f5
    position fixed
    bottom 0
    display flex
    .save-btn
      width: 662px;
      height: 90px;
      background: rgb(19,28,225);
      border: 1px solid #D8D8D8;
      border-radius: 44px;
      color #ffffff
      line-height 90px
      text-align center
      margin 20px 44px 57px 44px
    .del-btn
      width: 290px;
      height: 90px;
      background: rgb(19,28,225);
      border: 1px solid #D8D8D8;
      border-radius: 10px;
      color #ffffff
      line-height 90px
      text-align center
      margin 20px 44px 57px 44px
    .sub-btn
      width: 290px;
      height: 90px;
      background: #131177;
      border: 1px solid #D8D8D8;
      border-radius: 10px;
      color #ffffff
      line-height 90px
      text-align center
      margin 20px 44px 57px 44px
  .red-tips-txt
    color red
    font-size: 22px;
    margin-top: 5px;
</style>
